import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PreviewFooter from "./PreviewFooter";

const Footer = React.memo(function Footer() {
  const [footerHTML, setFooterHTML] = useState("");
  const [error, setError] = useState(null);
  const location = useLocation();
  const [pathName, setPathName] = useState("");

  useEffect(() => {
    setPathName(location.pathname);
  }, [location]);

  useEffect(() => {
    async function fetchFooter() {
      try {
        const response = await fetch("https://adam.newfold.com/api/v1/getExpFrag", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            brand: "NETWORKSOLUTIONS",
            env: "prod",
            expFrag: "/content/experience-fragments/netsol/site-footer/master",
          }),
        });

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const data = await response.json();
        const fragment = data?.response;

        if (!fragment?.bodyContent) {
          throw new Error("Missing bodyContent in API response");
        }

        // Inject link tags (CSS)
        if (Array.isArray(fragment.linkTags)) {
          fragment.linkTags.forEach((tag) => {
            if (!tag.href) return;
            if (!document.querySelector(`link[href="${tag.href}"]`)) {
              const el = document.createElement("link");
              el.rel = tag.rel || "stylesheet";
              el.href = tag.href;
              if (tag.as) el.as = tag.as;
              if (tag.type) el.type = tag.type;
              if (tag.media) el.media = tag.media;
              document.head.appendChild(el);
            }
          });
        }

        // Inject script tags (JS)
        if (Array.isArray(fragment.scriptTags)) {
          fragment.scriptTags.forEach((tag) => {
            if (!tag.src) return;
            if (!document.querySelector(`script[src="${tag.src}"]`)) {
              const el = document.createElement("script");
              el.src = tag.src;
              el.async = false;
              if (tag.type) el.type = tag.type;
              document.body.appendChild(el);
            }
          });
        }

        // Set final HTML
        setFooterHTML(fragment.bodyContent);
      } catch (err) {
        console.error("Footer load error:", err);
        setError("Failed to load footer content");
      }
    }

    fetchFooter();
  }, []);

  // Add query params and current year after HTML is injected
  useEffect(() => {
    if (!footerHTML) return;

    const yearSpan = document.getElementById("currentYear");
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear();
    }

    document.querySelectorAll("footer a").forEach((anchor) => {
      const href = anchor.getAttribute("href");
      if (!href) return;
      if (href === "#") return;

      try {
        const url = new URL(href, window.location.origin);
        url.searchParams.set("brand", "register");
        url.searchParams.set("siteID", "100");
        url.searchParams.set("channelID", "P99C100S653N0B5A1D0E0000V102");
        anchor.setAttribute("href", url.toString());
      } catch {
        // ignore invalid URLs
      }
    });
  }, [footerHTML]);

  if(pathName === "/sitegeneration/preview") {
    return <PreviewFooter />;
  }

  return (
    <footer
      className="footer-wrapper"
      dangerouslySetInnerHTML={{
        __html: error
          ? `<div style="color: red; text-align:center; padding: 1rem;">${error}</div>`
          : footerHTML,
      }}
    />
  );
})

export default Footer;
